import { ConnectedFolderCreateForm } from "fleet/controller/media-library/connected-folder-create-form";
import PropTypes from "prop-types";
import React from "react";
import { Button, Card, Col, Modal, Row } from "react-bootstrap";
import Icon from "ui/icon";

class MediaFolderModal extends React.Component {
  static get displayName() {
    return "MediaFolderModal";
  }

  static get propTypes() {
    return {
      onClose: PropTypes.func.isRequired,
      onMove: PropTypes.func.isRequired,
      folder: PropTypes.object,
      folders: PropTypes.array,
      isVisible: PropTypes.bool,
    };
  }

  static get defaultProps() {
    return {
      isVisible: false,
    };
  }

  constructor(props) {
    super(props);
    this.state = this._getEmptyState();

    this._close = this._close.bind(this);
    this._move = this._move.bind(this);
    this._selectFolder = this._selectFolder.bind(this);
  }

  _getEmptyState() {
    return {
      isFolderSelected: false,
      selected: null,
    };
  }

  _close() {
    this.setState(this._getEmptyState(), () => {
      this.props.onClose();
    });
  }

  _move() {
    const { selected } = this.state;
    this.setState(this._getEmptyState(), () => {
      this.props.onMove(selected);
    });
  }

  _selectFolder(folderId) {
    this.setState({ isFolderSelected: true, selected: folderId });
  }

  _renderFolders(folders, selected, curFolderId) {
    return folders.map((folder) => {
      const isCurFolder = curFolderId && folder.id === curFolderId;
      if (isCurFolder) {
        return null;
      }

      return (
        <Button
          key={folder.id}
          active={folder.id === selected}
          className="media-folder-btn"
          onClick={() => this._selectFolder(folder.id)}
        >
          <Icon name="folder" status="success" />
          {` ${folder.name}`}
        </Button>
      );
    });
  }

  _renderRemoveBtn(currentFolderId, active) {
    if (!currentFolderId) {
      return null;
    }

    return (
      <Row>
        <Col xs={6}>
          <Button
            key="remove-from-folder"
            active={active}
            className="media-folder-btn"
            onClick={() => this._selectFolder(null)}
          >
            <Icon name="ban" status="danger" />
            Remove from folder and move to Media Library
          </Button>
        </Col>
      </Row>
    );
  }

  render() {
    const { folder, folders, isVisible } = this.props;
    const { isFolderSelected, selected } = this.state;
    const currentFolderId = folder ? folder.id : null;

    const isRemoveActive = selected === null && isFolderSelected;
    return (
      <Modal show={isVisible}>
        <Modal.Header>
          <Modal.Title>Move File(s)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {folders && (
            <Card className="mb-3" key="folder-list">
              <Card.Body>
                <p>Move file to an existing folder</p>
                {this._renderFolders(folders, selected, currentFolderId)}
                {this._renderRemoveBtn(currentFolderId, isRemoveActive)}
              </Card.Body>
            </Card>
          )}
          <p>Create a new folder:</p>
          <ConnectedFolderCreateForm key="create-folder-form" />
        </Modal.Body>
        <Modal.Footer>
          <Button key="close-modal" onClick={this._close} variant="secondary">
            Cancel
          </Button>
          <Button
            key="move-to-folder"
            disabled={!isFolderSelected}
            onClick={this._move}
            variant="primary"
          >
            Move
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default MediaFolderModal;
export { MediaFolderModal };
